import { render, staticRenderFns } from "./user_view.vue?vue&type=template&id=2539dbf1&scoped=true&"
import script from "./user_view.vue?vue&type=script&lang=js&"
export * from "./user_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539dbf1",
  null
  
)

export default component.exports